module.exports = __webpack_public_path__ + "img/menu-huay.cb6dfe95.png";